import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { APIService } from '../common/api.component';
import { Utils } from '../common/utils.component'
import { Subject, Subscription } from 'rxjs';
import { SharedService } from '../common/shared.service';
import { Constants } from '../common/constants';
import { ShareLink } from '../models/sharelink';
import { MatDialog } from '@angular/material/dialog';
import { ShareUtils } from '../common/shareutils';
import { takeUntil } from "rxjs/operators";

export enum SelectionType {
  All,
  Folders,
  Files
}
@Component({
  selector: 'app-recent',
  templateUrl: './recent.component.html'
})
export class RecentComponent implements OnInit, OnDestroy {
  subscription: Subscription;
  clickedRow: any;
  highlightRow: object;
  share = new ShareLink();
 // sharetitle: string;
  selectionType: SelectionType;
  loadingMessage: string;
  private onDestroy$: Subject<void> = new Subject<void>();
  recentlist: any
  isShare: boolean;
  errorMsg = { str : "" } 
  sharebutton={isDisabled:true,sharetitle:"",sharetitledefault:Constants.SHARE_LINK}


  constructor(
    private apiService: APIService,
    private utils: Utils,
    private route: Router,
    private sharedService: SharedService,
    private dialog: MatDialog,
    private shareUtils: ShareUtils,
  ) {

    this.clickedRow = function (item) {
      this.clearErrorMsg()
      this.highlightRow = item;
      this.sharebutton.isDisabled = false;
    }

    this.subscription = sharedService.searchedText$
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        searchText => {
          this.clearErrorMsg()
          this.searchText = searchText;
        });

        this.subscription = sharedService.isShare$
        .pipe(takeUntil(this.onDestroy$))
        .subscribe(
          isShare => {
            this.isShare = isShare;
            if(!this.isShare){
              this.sharebutton.isDisabled = true
            }
          });
  

    this.subscription = sharedService.activeFilter$
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        filter => {
          if (filter == "All")
            this.selectionType = SelectionType.All;
          else if (filter == "Folders")
            this.selectionType = SelectionType.Folders;
          else if (filter == "Files")
            this.selectionType = SelectionType.Files;

          this.dataSelection(this.selectionType);
        });
    this.searchText = '';
  }

  recentdataOriginal: object[] = [];
  recentdata: object[] = [];
  recentdataPreviousSize: number;
  noOfcalls: number = 0;
  recentdatas: object[] = [];
  loading: boolean = true;
  isButtonVisible: boolean = false;
  limit: number = 100;
  currentActivityId: number = -1;
  lastActivityId: number;
//  isDisabled: boolean = true;
  searchText;
  noRecentData = Constants.NO_RECENT
 // sharetitledefault = Constants.SHARE_LINK

  ngOnInit() {
    this.apiService.ValidateMsTeamContextAndFatchTeamsId(this.sharedService);
    this.apiService.setTheme();
    this.sharedService.setLoading(this.loading);
    this.sharedService.setInsideFolderfiles(false);
    this.sharedService.setSeachText("")
    this.sharedService.setFilter("All");
  
    if (localStorage.getItem(Constants.SHOW_DIALOG_STORAGE) === 'true'|| localStorage.getItem(Constants.SHOW_DIALOG_STORAGE) === 'undefined'|| localStorage.getItem(Constants.SHOW_DIALOG_STORAGE)==null){
      this.sharebutton.sharetitle = Constants.NEXT;
      this.sharebutton.sharetitledefault= Constants.NEXT;
    }
    else{
      this.sharebutton.sharetitle = Constants.SHARE_LINK;
      this.sharebutton.sharetitledefault = Constants.SHARE_LINK;
    }
    this.getRecentActivities(0);
  }

  public dataSelection(type: SelectionType) {
    this.clearErrorMsg()
    if (type == SelectionType.All)
      this.recentdata = this.recentdataOriginal;
    else if (type == SelectionType.Folders) {
      this.recentdata = [];
      for (let item of this.recentdataOriginal) {
        if (item['contentitem']['type'] == 'folder')
          this.recentdata.push(item);
      }
    } else {
      this.recentdata = [];
      for (let item of this.recentdataOriginal) {
        if (item['contentitem']['type'] == 'files')
          this.recentdata.push(item);
      }
    }
  }

  getRecentActivities(lastActivityId: number) {
    this.apiService.getRecentActivities(lastActivityId, this.limit)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(recentlist => {
        this.recentlist = recentlist;
        this.lastActivityId = recentlist['lastactivityid'];

        if (this.recentdatas) {
          for (let item of recentlist['activity'])
            this.recentdatas.push(item);
        } else {
          this.recentdatas = recentlist['activity'];
        }
        if (this.recentdata)
          this.recentdataPreviousSize = this.recentdata.length;
        this.recentdata = this.recentdatas.map(e => e['contentitem']['id'])
          // store the indexes of the unique objects
          .map((e, i, final) => final.indexOf(e) === i && i)
          // eliminate the false indexes & return unique objects
          .filter((e) => this.recentdatas[e]).map(e => this.recentdatas[e])
          .filter(data=> data['contentitem']['filetype'] != "placeholder")
          .map(recent => ({
            ...recent,
              title: `${recent['contentitem']['type']}`=='files'?`${recent['contentitem']['title']}.${recent['contentitem']['filetype']}`:`${recent['contentitem']['title']}`,
              newtype:`${recent['contentitem']['type']}`=='files'?`file`:`folder`
          }));


        this.recentdataOriginal = [];
        for (let item of this.recentdata) {
          this.recentdataOriginal.push(item);
        }
        if (this.selectionType) {
          this.dataSelection(this.selectionType)
        }

        if ((this.recentdataPreviousSize == this.recentdata.length || this.recentdatas.length < 100) && this.noOfcalls == 0) {
          this.noOfcalls++;
          this.isButtonVisible = true;
          this.currentActivityId = this.lastActivityId;
          this.getRecentActivities(this.lastActivityId)
          return;
        }
        this.noOfcalls = 0;
        this.loading = false;
        this.sharedService.setLoading(this.loading);
        if (this.lastActivityId == null) {
          this.isButtonVisible = false;
          return;
        }
        this.isButtonVisible = true;
        this.loadingMessage = Constants.LOAD_MORE_RESULTS

      }, err => {
        this.loading = false
        this.sharedService.setLoading(this.loading);
        /* this.utils.openErrorDialog({ errorData: err }, this.dialog, item => {
        // Error callback can be put here
        }) */
        this.errorMsg.str = err.errorMsg
      });
  }

  ngAfterViewChecked() {
    if (!this.loading) {
      this.utils.setContentHeight(this.isButtonVisible, true, false, false, true);
    }
  }

  public loadMore() {
    this.clearErrorMsg()
    if (this.loadingMessage == Constants.LOADING)
      return;
    if (this.currentActivityId != this.lastActivityId) {
      this.currentActivityId = this.lastActivityId;
      this.loadingMessage =  Constants.LOADING
      this.getRecentActivities(this.lastActivityId);
    } else {
      this.isButtonVisible = false;
    }
  }

  public getFileIcon(type: string) {
    return this.utils.getFileIcon(type);
  }

  clearSearchField() {
    this.searchText = '';
  }

  openFolder(item, contentId: number, contentTitle: string, type: string) {
    this.clearErrorMsg()
    if (type === 'folder'){
      var folderobj = {
        name: item['contentitem']['title'],
        type: item['contentitem']['filetype'],
        id: item['contentitem']['id'],
        location: item['contentitem']['location'],
        size: item['contentitem']['filesize'],
        modifieddate: item['timepublished'],
        foldertype:item['contentitem']['foldertype']
      }
      this.route.navigate(['/folder', contentId, 'Recent', contentTitle], { state: { siteName: item.sitename, parentfolderType:item.contentitem.foldertype,parentfolder:folderobj}});
    }
    else
      this.clickedRow(item)
  }
  shareItem() {
    this.clearErrorMsg()
    var recent = this.highlightRow;

   if(recent['contentitem']['type']  == 'folder'&& recent['contentitem']['foldertype'] && recent['contentitem']['foldertype']=='SMART'){
       this.errorMsg.str = Constants.SMART_FOLDER_SHARE_LINK;
       return;
   }

    var filefoldername;
    var types;
    if (recent['contentitem']['type'] == 'folder') {
      filefoldername = recent['contentitem']['title']
      types = recent['contentitem']['type'];
    }
    else {
      filefoldername = recent['contentitem']['title'] + "." + recent['contentitem']['filetype'];
      types = "file";
    }
    var fileFolderobj = {
      filefoldername: filefoldername,
      types: types,
      fileType: recent['contentitem']['filetype'],
      contentId: recent['contentitem']['id'],
      locations: recent['contentitem']['location'],
      fileSize: recent['contentitem']['filesize'],
      lastmodified: recent['timepublished'],
      foldertype:recent['contentitem']['foldertype']
    }
    
    if (localStorage.getItem(Constants.SHOW_DIALOG_STORAGE) === 'true' || localStorage.getItem(Constants.SHOW_DIALOG_STORAGE) === 'undefined'|| localStorage.getItem(Constants.SHOW_DIALOG_STORAGE)==null) {
      this.utils.openDialog(this.apiService, this.dialog, fileFolderobj, this.shareUtils, this.share, false,this.sharedService,this.errorMsg,this.sharebutton);
    } else {
      this.sharebutton.sharetitle=Constants.GENERATING_LINK
      this.sharebutton.isDisabled=true;
      if (localStorage.getItem(Constants.LINKEXPIRES_STORAGE) != null) {
        this.shareUtils.generateSharelink(fileFolderobj, this.share, this.apiService, null, this.utils, this.dialog, this.shareUtils,this.sharedService,this.errorMsg,this.sharebutton)
      } else {
        this.utils.getSettings(this.apiService, this.dialog, false, fileFolderobj, this.shareUtils, this.share, false,this.sharedService,this.errorMsg,this.sharebutton)
      }
    }
  }

  clearErrorMsg() {
    this.errorMsg.str = ""
  }

  checkRadioButton(item){
    this.clickedRow(item)
  }

  closeDialog() {
    this.shareUtils.closeMainDialog(this.apiService);
  }

  getText(title,extension){
    if(extension)
     return this.utils.getHtmlEncodeString(title)+"."+extension;
    else 
     return this.utils.getHtmlEncodeString(title);
  }

  public ngOnDestroy(): void {
    this.subscription.remove(this.subscription);
    this.subscription.unsubscribe();
    this.onDestroy$.next();
  }
}
